
import React, { Component } from "react";

import rightarrow from "../images/right-arrow.svg"
import leftarrow from "../images/left-arrow.svg"

import "../css/patients.css"

 

class LeadingDoctors extends React.Component{
    render(){
       
       return(
        <section class="leading-doc-sec">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="leading-doc-inner">
                        <h2>Offered by Leading Doctors</h2>
                        <div class="row"> 
                            <div class="col-12 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".1s"> 
                                <div class="swiper-container leading-swiper">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide"> 
                                            <div class="leading-doc-box">
                                                <div class="image-holder">
                                                    <img data-src="https://res.cloudinary.com/image/upload/v1605087788/NewHome/Dr._Arun_Vadavi-min_a4roef.png" alt="" class="img-fluid lazyload" />
                                                </div>
                                                <div class="text-box">
                                                    
                                                    <p>I believe the structure of the program on a solid scientific footing and it’s meticulous execution are the two main pillars of its remarkable success.</p>
                                                    <h3><span>Dr. Arun Vadavi</span></h3>
                                                    <h4>38+ years of Experience, Bangalore</h4>
                                                </div>
                                            </div> 
                                        </div>
                                        <div class="swiper-slide"> 
                                            <div class="leading-doc-box">
                                                <div class="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1605087786/NewHome/Dr._Paramesh_Shamanna-min_cmmefp.png" alt="" class="img-fluid lazyload" />
                                                </div>
                                                <div class="text-box">
                                                    
                                                    <p>From healthy food options to holistic healing and natural skincare, here’s how my patients can stay fit and look their best.</p>
                                                    <h3><span>Dr. Paramesh Shamanna</span></h3>
                                                    <h4>25+ years of Experience, Bangalore Diabetes Centre</h4>
                                                </div>
                                            </div> 
                                        </div>
                                        <div class="swiper-slide"> 
                                            <div class="leading-doc-box">
                                                <div class="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1605087787/NewHome/Dr._Mala_Dharmalingam-min_y2azha.png" alt="" class="img-fluid lazyload" />
                                                </div>
                                                <div class="text-box">
                                                   
                                                    <p>The program is working very well for my patients.</p>
                                                    <h3><span>Dr. Mala Dharmalingam</span></h3>
                                                    <h4>
Bangalore Endocrinology & Diabetes Research Centre

                                                    </h4>
                                                </div>
                                            </div> 
                                        </div>
                                        <div class="swiper-slide"> 
                                            <div class="leading-doc-box">
                                                <div class="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1605087786/NewHome/Dr._Sharat_Honnatti-min_udbbnb.png" alt="" class="img-fluid lazyload" />
                                                </div>
                                                <div class="text-box">
                                                    
                                                   
                                                    <p>Twin has brought the revolution in diabetes treatment. It has changed our perspective of it being a progressive chronic disease.</p>
                                                    <h3><span>Dr. Sharat Honnati</span></h3>
                                                    <h4>16+ years of Experience</h4>
                                                </div>
                                            </div> 
                                        </div>
                                        <div class="swiper-slide"> 
                                            <div class="leading-doc-box">
                                                <div class="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1605087788/NewHome/Dr._Abul_Hassan-min_imzg4v.png" alt="" class="img-fluid lazyload" />
                                                </div>
                                                <div class="text-box">
                                                   
                                                   
                                                    <p>We need to stop thinking about diabetes as a lifelong disease. Patients can reverse diabetes through good nutrition and moderate activity- with Twin technology.</p>
                                                    <h3><span>Dr. Abul Hassan</span></h3>
                                                    <h4>20+ years of Experience</h4>
                                                </div>
                                            </div> 
                                        </div>
                                        <div class="swiper-slide"> 
                                            <div class="leading-doc-box">
                                                <div class="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1605087786/NewHome/Dr._Vikram_Akula-min_x4dmmp.png" alt="" class="img-fluid lazyload" />
                                                </div>
                                                <div class="text-box">
                                                    
                                                   
                                                    <p>TWIN HEALTH A positive ray of hope that can change hectic diabetic life to a healthy blissful life!</p>
                                                    <h3><span>Dr. Akula Vikram</span></h3>
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                     {/* Add Pagination  */}
                                    <div class="swiper-pagination"></div>

                                </div>  
                                {/* <div class="swipe-arrow">
                                    <div class="swiper-button-next"><img src={rightarrow} alt="" /></div>
                                    <div class="swiper-button-prev"><img src={leftarrow} alt="" /></div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> 
              )
    }
}
export default LeadingDoctors;